import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { getEntityImage } from "../../utils/assetUtils.js";
const PinnedProductContext = ({
  pageContext,
  product,
  isLoading = false
}) => {
  var _a;
  if ((pageContext == null ? void 0 : pageContext.pageType) !== "pdp" || !(pageContext == null ? void 0 : pageContext.stacklineSku)) {
    return null;
  }
  const stacklineSku = pageContext.stacklineSku;
  const imageUrl = ((_a = product == null ? void 0 : product.imageUrls) == null ? void 0 : _a[0]) || getEntityImage(stacklineSku, "product");
  const productTitle = product == null ? void 0 : product.title;
  const brandName = product == null ? void 0 : product.brandName;
  if (isLoading) {
    return /* @__PURE__ */ jsxs(
      "div",
      {
        style: {
          display: "flex",
          alignItems: "center",
          gap: "12px",
          padding: "10px 16px",
          backgroundColor: "#f8fafc",
          borderBottom: "1px solid #e2e8f0"
        },
        children: [
          /* @__PURE__ */ jsx(
            "div",
            {
              style: {
                width: "40px",
                height: "40px",
                borderRadius: "8px",
                backgroundColor: "#e2e8f0",
                flexShrink: 0
              }
            }
          ),
          /* @__PURE__ */ jsxs(
            "div",
            {
              style: {
                flex: 1,
                display: "flex",
                flexDirection: "column",
                gap: "4px"
              },
              children: [
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    style: {
                      height: "10px",
                      width: "80px",
                      borderRadius: "4px",
                      backgroundColor: "#e2e8f0"
                    }
                  }
                ),
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    style: {
                      height: "14px",
                      width: "150px",
                      borderRadius: "4px",
                      backgroundColor: "#e2e8f0"
                    }
                  }
                )
              ]
            }
          )
        ]
      }
    );
  }
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "10px 16px",
        backgroundColor: "#f8fafc",
        borderBottom: "1px solid #e2e8f0"
      },
      children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              width: "40px",
              height: "40px",
              borderRadius: "8px",
              overflow: "hidden",
              backgroundColor: "#ffffff",
              border: "1px solid #e2e8f0",
              flexShrink: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            },
            children: /* @__PURE__ */ jsx(
              "img",
              {
                src: imageUrl,
                alt: productTitle || "Product",
                style: {
                  width: "100%",
                  height: "100%",
                  objectFit: "contain"
                },
                onError: (e) => {
                  e.target.style.display = "none";
                }
              }
            )
          }
        ),
        /* @__PURE__ */ jsxs(
          "div",
          {
            style: {
              flex: 1,
              minWidth: 0,
              // Allow text truncation
              display: "flex",
              flexDirection: "column",
              gap: "1px"
            },
            children: [
              /* @__PURE__ */ jsx(
                "span",
                {
                  style: {
                    fontSize: "11px",
                    fontWeight: 500,
                    color: "#3b82f6",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px"
                  },
                  children: "Chatting about"
                }
              ),
              productTitle ? /* @__PURE__ */ jsxs(Fragment, { children: [
                /* @__PURE__ */ jsx(
                  "span",
                  {
                    style: {
                      fontSize: "13px",
                      fontWeight: 600,
                      color: "#1e293b",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      lineHeight: "1.3"
                    },
                    title: productTitle,
                    children: productTitle
                  }
                ),
                brandName && /* @__PURE__ */ jsx(
                  "span",
                  {
                    style: {
                      fontSize: "11px",
                      fontWeight: 400,
                      color: "#64748b",
                      lineHeight: "1.2"
                    },
                    children: brandName
                  }
                )
              ] }) : /* @__PURE__ */ jsx(
                "span",
                {
                  style: {
                    fontSize: "13px",
                    fontWeight: 500,
                    color: "#1e293b",
                    lineHeight: "1.3"
                  },
                  children: "This product"
                }
              )
            ]
          }
        )
      ]
    }
  );
};
export {
  PinnedProductContext
};
//# sourceMappingURL=PinnedProductContext.js.map
